/**
 * SolutionsMatrix cursor glow. Vanilla JS sets --mx and --my on each card
 * for the radial-gradient overlay in SCSS. Disabled on touch.
 */
(function () {
    'use strict';

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.addEventListener('DOMContentLoaded', function () {
        var cards = document.querySelectorAll('.mnhq-solutions__card');
        cards.forEach(function (card) {
            card.addEventListener('mousemove', function (e) {
                var r = card.getBoundingClientRect();
                var mx = ((e.clientX - r.left) / r.width) * 100;
                var my = ((e.clientY - r.top) / r.height) * 100;
                card.style.setProperty('--mx', mx + '%');
                card.style.setProperty('--my', my + '%');
            });
        });
    });
})();
